import { render, staticRenderFns } from "./SiteHistory.vue?vue&type=template&id=08640f85"
import script from "./SiteHistory.vue?vue&type=script&lang=js"
export * from "./SiteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports